import { currentTimeMillis, Module } from '@nu-art/ts-common';
export class ModuleFE_ActiveUser_Class extends Module {
    userActive = false;
    timeoutShort;
    timeoutMax;
    expirationTimeMax;
    pendingOrder = false;
    activeSandbox = false;
    constructor() {
        super();
        this.setDefaultConfig({ maxTTL: 60000 });
    }
    /**
     * Record an interaction by the user. Resets timers based on short TTL and max TTL.
     * @param message - Message to log for interaction
     * @param ttl - Short TTL in ms before user is considered inactive if no new activity occurs
     */
    setUserActive(message, ttl) {
        const now = currentTimeMillis();
        const shortExpiration = now + ttl;
        const maxExpiration = this.expirationTimeMax ?? now + this.config.maxTTL;
        const remaining = Math.min(shortExpiration, maxExpiration) - now;
        this.logDebug(`User active: ${message} (active for ${remaining} ms)`);
        this._setActive(true);
        if (this.timeoutShort)
            clearTimeout(this.timeoutShort);
        this.timeoutShort = setTimeout(() => {
            this._setActive(false);
        }, ttl);
        if (ttl < this.config.maxTTL && !this.timeoutMax) {
            this.expirationTimeMax = maxExpiration;
            this.timeoutMax = setTimeout(() => {
                clearTimeout(this.timeoutShort);
                this._setActive(false);
            }, this.config.maxTTL);
        }
    }
    sandbox = {
        onOpen: () => {
            this.activeSandbox = true;
        },
        onClose: () => {
            this.activeSandbox = false;
        }
    };
    onOrderPlaced() {
        this.pendingOrder = true;
    }
    onApplicationTriedToClose() {
        this.pendingOrder = false;
    }
    isUserActive() {
        return this.activeSandbox || this.pendingOrder || this.userActive;
    }
    _setActive(active) {
        if (this.userActive === active)
            return;
        this.userActive = active;
        this.logInfo(`User is now ${active ? 'active' : 'inactive'}`);
        // Optionally: dispatch an event or callback
    }
}
export const ModuleFE_ActiveUser = new ModuleFE_ActiveUser_Class();
//# sourceMappingURL=ModuleFE_ActiveUser.js.map